import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MdlModule } from '@angular-mdl/core';
import { MdlSelectModule } from '@angular-mdl/select';
import { MdlExpansionPanelModule } from '@angular-mdl/expansion-panel';
import { MatTooltipModule } from '@angular/material/tooltip';

import { StripeAddNewPaymentComponent } from './stripe-add-new-payment.component';
import { TranslateModule } from '../../../translate/translate.module';
import { PipeModule } from '../../../pipes/pipes.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { SharedService } from '../../services/shared.service';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        HttpModule,
        MdlModule,
        MdlExpansionPanelModule,
        TranslateModule,
        PipeModule,
        MdlSelectModule,
        MatTooltipModule,
        DirectivesModule,
    ],
    declarations: [
        StripeAddNewPaymentComponent
    ],
    entryComponents: [
        StripeAddNewPaymentComponent
    ],
    exports: [
        StripeAddNewPaymentComponent
    ],
    providers: [
        SharedService
    ]
})

export class StripeAddNewPaymentModule {
    constructor(
        private readonly _sharedService: SharedService
    ) {
        this._sharedService.setTranslateLanguage();
    }
}
